import {atom} from "jotai";

export const adminInfoAtom = atom(null)


